import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import About from "@/components/About";
import Services from "@/components/Services";
import DieselOrder from "@/components/DieselOrder";
import Fleet from "@/components/Fleet";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";

export default function Home() {
  return (
    <div className="bg-[#0B132B] text-slate-100 min-h-screen" data-testid="motaps-app">
      <Header />
      <main>
        <Hero />
        <Marquee />
        <About />
        <Services />
        <DieselOrder />
        <Fleet />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
